// extracted by mini-css-extract-plugin
module.exports = {"date":"ChatMessagePage_date__1WaEX","newMessagePrompt":"ChatMessagePage_newMessagePrompt__NVzd9"};